import classNames from 'classnames';
import React, { useEffect, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import PageTitle from '~/common/components/PageTitle';
import useMediaQuery from '~/common/hooks/useMediaQuery';
import ProductsContainer from '../containers/Products';
import styles from './Products.css';

import { useAxeAccountAnalytics } from '~/common/contexts/analytics';
import usePurchaseNotification from '~/common/hooks/usePurchaseNotification';

const ProductsPage = (): ReactElement => {
  const { t } = useTranslation();
  const narrow = useMediaQuery('(max-width: 31.25rem)');
  const analytics = useAxeAccountAnalytics();

  usePurchaseNotification();

  useEffect(() => {
    analytics.viewProductsPage();
  }, []);

  return (
    <>
      <PageTitle title={t('Products')} />
      <div
        className={classNames(styles.wrap, {
          // This is manged in JS, rather than CSS to help keep in sync with
          // the panel breakpoint
          [styles.collapsed]: narrow
        })}
      >
        <h1>{t('Products')}</h1>
        <p className={styles.mainMessage}>
          {t('You can view and manage your products.')}
        </p>
        <ProductsContainer />
      </div>
    </>
  );
};

export default ProductsPage;
